"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigSchema = void 0;
const _imports_1 = require("./_imports");
exports.ConfigSchema = _imports_1.z.object({
    startDate: _imports_1.Utils.ZodFullDateStrStruct,
    endDate: _imports_1.Utils.ZodFullDateStrStruct,
    amount: _imports_1.z.number(),
});
//# sourceMappingURL=CommitmentAmount.js.map